// extracted by mini-css-extract-plugin
module.exports = {"container":"Settings_container__2zJAD","image":"Settings_image__aMd6B"};